import React from 'react'
import PropTypes from 'prop-types'

import { trackEvent } from '../../../../utils/analytics'
import { Button } from './style'
import ExternalLink from './components/externalLink'

const ReadMoreButton = React.memo(({ link }) => (
  <Button
    href={link}
    onClick={() => {
      trackEvent('clicked-read-more', 'click', link)
    }}
  >
    Les mer om nabolaget <ExternalLink />
  </Button>
))

ReadMoreButton.propTypes = {
  link: PropTypes.string.isRequired,
}

export default ReadMoreButton
